import { ChevronDown, ChevronUp } from '@cohesic/react-icons'
import styled from 'styled-components'

import { theme } from '@app/utils/theme'

export const ControlRow = styled.div`
  flex: 1;
  display: flex;
  width: 100%;
  padding: 1rem 0;
`

export const Control = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: baseline;

  &:first-child {
    margin-right: auto;
  }

  &:last-child {
    margin-right: auto;
  }
`

export const BackButton = styled.button`
  border: none;
  outline: none;
  background: ${(props) => props.theme.colors.primary};
  line-height: 45px;
  font-weight: 500;
  border-radius: 50%;
  border: 2px solid ${(props) => props.theme.colors.primary};
  color: white;
  text-align: center;
  padding: 0px;
  text-decoration: none;
  height: 60px;
  width: 60px;
  transition: background 400ms;
  box-shadow: rgb(0 0 0 / 25%) 0px 8px 8px -2px,
    rgb(0 0 0 / 20%) 0px 7px 8px 0px, rgb(0 0 0 / 15%) 0px 5px 12px 0px;

  &:active {
    background: ${(props) => props.theme.colors.secondary};
  }
`

export const ContinueButton = styled.button`
  background: ${(props) => props.theme.colors.primary};
  color: white;
  font-weight: 600;
  padding: 1rem;
  width: 120px;
  border: none;
  outline: none;
  border-radius: 10px;
  transition: background 400ms;
  box-shadow: rgb(0 0 0 / 25%) 0px 8px 8px -2px,
    rgb(0 0 0 / 20%) 0px 7px 8px 0px, rgb(0 0 0 / 15%) 0px 5px 12px 0px;

  &:active {
    background: ${(props) => props.theme.colors.secondary};
  }
`

export const ClearButton = styled(ContinueButton)`
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  padding: 0.75rem;
  background: white;
  border: 1px solid ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.primary};
  width: 200px;
`
export const ScrollDown = styled(ChevronDown)`
  stroke: ${theme.colors.gray};
  margin: 5px;
  animation: bounce 5s infinite;
  -webkit-animation: bounce 5s infinite;
  -moz-animation: bounce 5s infinite;

  @keyframes bounce {
    0%,
    20%,
    50%,
    80%,
    100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-15px);
    }
    60% {
      transform: translateY(-5px);
    }
  }
`

export const ScrollUp = styled(ChevronUp)`
  margin: 5px;
  animation: bounce 5s infinite;
  -webkit-animation: bounce 5s infinite;
  -moz-animation: bounce 5s infinite;
  stroke: ${theme.colors.gray};

  @keyframes bounce {
    0%,
    20%,
    50%,
    80%,
    100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(15px);
    }
    60% {
      transform: translateY(5px);
    }
  }
`
